module.exports = __webpack_public_path__ + "img/章庆元.2b91e5f8.jpg";